import {
    emailSchema,
    passwordSchema,
    phoneSchema,
    textSchema,
} from "../../../shared/lib/schemas/common.schema";
import { z } from "zod";
import { makeOptional } from "../../../shared/lib/helpers/schema.helpers";


export const signupForm1Schema = z
    .object({
        fullname: textSchema(),
        email: emailSchema,
        phone: phoneSchema,
        // Optional for volunteers (OTP login); required for homeowners
        password: makeOptional(passwordSchema),
        confirmPassword: makeOptional(passwordSchema),
        // Optional address fields for homeowners
        address: makeOptional(textSchema()),
        city: makeOptional(z.string()),
        state: makeOptional(z.string()),
        zipCode: makeOptional(z.string()),
        latitude: makeOptional(z.number()),
        longitude: makeOptional(z.number()),
        // Nested home object for RegisterStateCountryAutocomplete component
        home: makeOptional(
            z.object({
                address: makeOptional(textSchema()),
                city: makeOptional(z.string()),
                state: makeOptional(z.string()),
                zipCode: makeOptional(z.string()),
                latitude: makeOptional(z.number()),
                longitude: makeOptional(z.number()),
            }),
        ),
    })
    .refine(
        (data) =>
            (!data.password && !data.confirmPassword) ||
            data.password === data.confirmPassword,
        {
            message: 'Passwords do not match',
            path: ['confirmPassword'],
        },
    )

// Schema for Google signup info (simplified - only requires name, email, phone)
export const googleSignupInfoSchema = z.object({
    fullname: textSchema(),
    email: emailSchema,
    phone: phoneSchema,
})

export const signupFormSchema = z.object({
    form1: signupForm1Schema,
})